import styled from 'styled-components';

const VolumeContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default VolumeContainer;
